var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"departure_monitor__delay",domProps:{"innerHTML":_vm._s(_vm.delay)}})}
var staticRenderFns = []

export { render, staticRenderFns }